export default "__VITE_ASSET__qcF9rrTG__"